const toList = value => (Array.isArray(value) ? value : [])

const findByKey = (nodes, key) => toList(nodes).find(node => node?.key === key)

const normalizePricingTier = tier => ({
  ...tier,
  rank: tier?.rank,
  volumeRange: tier?.volumeRange || tier?.volume_range || tier?.vol || "",
  priceMonthly:
    typeof tier?.priceMonthly !== "undefined"
      ? tier.priceMonthly
      : typeof tier?.price_monthly !== "undefined"
        ? tier.price_monthly
        : typeof tier?.price !== "undefined"
          ? tier.price
          : undefined,
  supportingText: tier?.supportingText || tier?.supporting_text || "",
  ctaLabel: tier?.ctaLabel || tier?.cta_label || "",
})


export const pickCollectionNode = (nodes, selectedKey, fallbackKey = "") =>
  findByKey(nodes, selectedKey) || findByKey(nodes, fallbackKey) || toList(nodes)[0] || {}

export const resolveProofCollection = (nodes, selectedKey, fallbackKey = "") =>
  (() => {
    const base = pickCollectionNode(nodes, selectedKey, fallbackKey)
    const sourceKey = base?.sourceCollection?.key
    const source = sourceKey ? findByKey(nodes, sourceKey) || base : base
    const resolved = {
      ...source,
      ...base,
    }

    if (toList(resolved.selectedProfileEntries).length > 0) {
      resolved.profiles = resolved.selectedProfileEntries
    } else if (toList(resolved.profileEntries).length > 0) {
      resolved.profiles = resolved.profileEntries
    }

    if (toList(resolved.selectedTestimonialEntries).length > 0) {
      resolved.testimonials = resolved.selectedTestimonialEntries
    } else if (toList(resolved.testimonialEntries).length > 0) {
      resolved.testimonials = resolved.testimonialEntries
    }

    return resolved
  })()

export const resolvePricingCollection = (nodes, selectedKey, fallbackKey = "") =>
  (() => {
    const base = pickCollectionNode(nodes, selectedKey, fallbackKey)
    const sourceKey = base?.sourceCollection?.key
    const source = sourceKey ? findByKey(nodes, sourceKey) || base : base
    const resolved = {
      ...source,
      ...base,
    }

    if (toList(resolved.selectedPricingTierEntries).length > 0) {
      resolved.pricingTiers = resolved.selectedPricingTierEntries.map(normalizePricingTier)
    } else if (toList(resolved.pricingTierEntries).length > 0) {
      resolved.pricingTiers = resolved.pricingTierEntries.map(normalizePricingTier)
    } else if (toList(resolved.pricingTiers).length > 0) {
      resolved.pricingTiers = resolved.pricingTiers.map(normalizePricingTier)
    }

    return resolved
  })()

export const resolveFaqCollection = (nodes, selectedKey, fallbackKey = "") =>
  (() => {
    const base = pickCollectionNode(nodes, selectedKey, fallbackKey)
    const sourceKey = base?.sourceCollection?.key
    const source = sourceKey ? findByKey(nodes, sourceKey) || base : base
    const resolved = {
      ...source,
      ...base,
    }

    if (toList(resolved.selectedFaqEntries).length > 0) {
      resolved.faqItems = resolved.selectedFaqEntries
      return resolved
    }

    return resolved
  })()
